export * from './delete-abteilung.command.module';
export * from './component';
export * from './service';